import { memo, useMemo } from 'react';

import useTranslation from '@Queries/useTranslation';
import formatPrice from '@Utils/formatPrice';
import UILink from '@UI/Link';
import styles from './CounterPoints.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface CounterPointsProps extends HTMLAttributes<HTMLDivElement> {
  count: number;
  prefixMode?: 'income' | 'from' | 'default';
}

const CounterPoints: FC<CounterPointsProps> = (props) => {
  const { count, prefixMode, ...restProps } = props;
  const { t } = useTranslation();
  const bonusesAmount = t('ui.plural-bonuses', count);

  const prefix = useMemo(() => {
    if (!prefixMode || prefixMode === 'default') return '';
    if (prefixMode === 'income') return '+';
    if (prefixMode === 'from') return 'от ';
  }, [prefixMode]);

  return (
    <div {...restProps}>
      <UILink view='primary' className={styles.text}>{`${prefix}${formatPrice(
        count,
      )} ${bonusesAmount}`}</UILink>
    </div>
  );
};

export default memo(CounterPoints);
